import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { AGENT } from "@/lib/site";

const links = [
  { href: "#storitve", label: "Storitve" },
  { href: "#kalkulatorji", label: "Kalkulatorji" },
  { href: "#dokumenti", label: "Pomoč" },
  { href: "#o-meni", label: "O meni" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[var(--vp-border)]/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-white"
            style={{ background: "var(--vp-primary)" }}
          >
            <ShieldCheck size={20} />
          </span>
          <span className="font-display font-bold text-lg tracking-tight">
            {AGENT.company.split(" ")[0]}{" "}
            <span className="text-[var(--vp-primary)]">{AGENT.company.split(" ")[1]}</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-sm font-medium text-[var(--vp-muted)] hover:text-[var(--vp-primary)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/admin/login"
            data-testid="admin-link"
            className="text-sm text-[var(--vp-muted)] hover:text-[var(--vp-text)]"
          >
            Admin
          </Link>
          <a
            href="#kontakt"
            data-testid="header-cta"
            className="inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-colors"
            style={{ background: "var(--vp-primary)" }}
          >
            Rezervirajte posvet
          </a>
        </div>

        <button
          aria-label="Meni"
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--vp-border)] bg-white/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium py-2 text-[var(--vp-muted)]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="rounded-full px-5 py-3 text-center text-white font-semibold mt-2"
              style={{ background: "var(--vp-primary)" }}
            >
              Rezervirajte posvet
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
